import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  serviceVerification: [],
  allServiceVerification: [],
  allServiceVerificationCount: [],
};

export const ServiceVerificationsSlice = createSlice({
  name: "serviceVerifications",
  initialState,
  reducers: {
    getServiceVerificationsAction: (state, action) => {
      state.allServiceVerification = action.payload;
    },
    getServiceVerificationsCountAction: (state, action) => {
      state.allServiceVerificationCount = action.payload;
    },
    getServiceVerificationAction: (state, action) => {
      state.serviceVerification = action.payload;
    },
  },
});

export default ServiceVerificationsSlice.reducer;

export const { getServiceVerificationsAction, getServiceVerificationsCountAction, getServiceVerificationAction } = ServiceVerificationsSlice.actions;
